import { makeService } from './api';

const service = makeService('dunning_letters');

export default service;